/**
 * ANQ.UserProfile.API 
 * User Profile Service
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface VerifyAccountModelResponseDto { 
    firstName?: string;
    lastName?: string;
    userName?: string;
    tenantId?: string;
    email?: string;
    phoneNo?: string;
    roles?: Array<string>;
}